// Pack UUIDs as raw bytes (16 bytes each) and base64url-encode.
// ~42% smaller than base64url-encoding the hyphenated UUID CSV string.
export function encodeGuids(guids: string[]): string {
  const bytes = new Uint8Array(guids.length * 16)
  guids.forEach((guid, i) => {
    const hex = guid.replace(/-/g, '')
    for (let j = 0; j < 16; j++) {
      bytes[i * 16 + j] = parseInt(hex.slice(j * 2, j * 2 + 2), 16)
    }
  })
  return btoa(Array.from(bytes, (b) => String.fromCharCode(b)).join(''))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '')
}

export function decodeGuids(input: string): string[] {
  let base64 = input.replace(/-/g, '+').replace(/_/g, '/')
  while (base64.length % 4) base64 += '='
  const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))
  const guids: string[] = []
  for (let i = 0; i < bytes.length; i += 16) {
    const hex = Array.from(bytes.slice(i, i + 16), (b) =>
      b.toString(16).padStart(2, '0')
    ).join('')
    guids.push(
      `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
        16,
        20
      )}-${hex.slice(20)}`
    )
  }
  return guids
}

// Legacy encoder for guidsB64 (base64url of comma-joined GUIDs)
export function legacyEncodeGuidsB64(guids: string[]): string {
  return btoa(guids.join(','))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '')
}

// Legacy decode for guidsB64 param sent by previously-deployed LocationMap clients
export function legacyDecodeGuidsB64(input: string): string[] {
  let base64 = input.replace(/-/g, '+').replace(/_/g, '/')
  while (base64.length % 4) base64 += '='
  return atob(base64).split(',')
}
